class CustomerDetails {
  constructor(
    id,
    pointOfSalesAlreadyUsed,
    pointOfSalesUsed,
    newOpen,
    installationDate,
    establishmentArea,
  ) {
    this._id = id;
    this._pointOfSalesAlreadyUsed = pointOfSalesAlreadyUsed;
    this._pointOfSalesUsed = pointOfSalesUsed;
    this._newOpen = newOpen;
    this._installationDate = installationDate;
    this._establishmentArea = establishmentArea;
  }

  // Getters
  getId() {
    return this._id;
  }

  getPointOfSalesAlreadyUsed() {
    return this._pointOfSalesAlreadyUsed;
  }

  getPointOfSalesUsed() {
    return this._pointOfSalesUsed;
  }

  getNewOpen() {
    return this._newOpen;
  }

  getInstallationDate() {
    return this._installationDate;
  }

  getEstablishmentArea() {
    return this._establishmentArea;
  }

  // Setters
  setId(newId) {
    this._id = newId;
    return this;
  }

  setPointOfSalesAlreadyUsed(newPointOfSalesAlreadyUsed) {
    this._pointOfSalesAlreadyUsed = newPointOfSalesAlreadyUsed;
    return this;
  }

  setPointOfSalesUsed(newPointOfSalesUsed) {
    this._pointOfSalesUsed = newPointOfSalesUsed;
    return this;
  }

  setNewOpen(newNewOpen) {
    this._newOpen = newNewOpen;
    return this;
  }

  setInstallationDate(newInstallationDate) {
    this._installationDate = newInstallationDate;
    return this;
  }

  setEstablishmentArea(newEstablishmentArea) {
    this._establishmentArea = newEstablishmentArea;
    return this;
  }

  serialize() {
    return { ...this, '@type': 'CustomerDetails' };
  }

  clone() {
    return new CustomerDetails(
      this._id,
      this._pointOfSalesAlreadyUsed,
      this._pointOfSalesUsed,
      this._newOpen,
      this._installationDate,
      this._establishmentArea,
    );
  }

  static deserialize(raw) {
    return new CustomerDetails(
      raw._id,
      raw._pointOfSalesAlreadyUsed,
      raw._pointOfSalesUsed,
      raw._newOpen,
      raw._installationDate,
      raw._establishmentArea,
    );
  }
}

export default CustomerDetails;



// WEBPACK FOOTER //
// ./src/models/CustomerDetails.js